import { Components, Theme } from '@mui/material';

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    basic: true;
    default: true;
  }
}

export const MuiCard: Components<Omit<Theme, 'components'>>['MuiCard'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        borderRadius: '12px',
        border: '1px solid',
        borderColor: theme.palette.surface.outlineVariant,
        boxShadow: 'none',
        backgroundColor: theme.palette.surfaceContainer.low,
        color: theme.palette.surface.onSurface,
        backgroundImage: 'none',

        '&::-webkit-scrollbar': {
          backgroundColor: 'transparent',
        },
      };
    },
  },
  variants: [
    {
      props: { variant: 'basic' },
      style: ({ theme }) => ({
        color: theme.palette.surface.onSurface,
        backgroundColor: theme.palette.surfaceContainer.high,
        borderRadius: 'unset',
        border: 'none',

        '& .MuiCardHeader-root': {
          padding: '16px 16px 0px 16px',
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.surfaceContainer.high,
          fontFamily: theme.typography.fontFamily,
        },

        '& .MuiCardContent-root': {
          padding: '0px 16px 16px 16px !important',
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.surfaceContainer.high,
        },
      }),
    },
    {
      props: { variant: 'default' },
      style: ({ theme }) => ({
        '& .MuiCardHeader-root': {
          padding: '16px 16px 12px 16px',
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.surfaceContainer.container,

          '& .MuiCardHeader-content .MuiTypography-root:last-of-type': {
            fontWeight: 400,
          },
        },
      }),
    },
  ],
};
